import hyphens from "@vivgui/tailwindcss-hyphens";
import mask from "tailwind-gradient-mask-image";
import type { Config } from "tailwindcss";
import animate from "tailwindcss-animate";
import { fontFamily, screens } from "tailwindcss/defaultTheme";

export default {
  content: ["./src/**/*.{ts,tsx}"],
  theme: {
    extend: {
      colors: {
        // defaults
        background: "#121212",
        "text-color": "#e1e1e1",
        "big-text-color": "#E3DDD3",
        "line-color": "hsla(0,0%,100%,.15)",
      },
      fontSize: {
        "3xl": ["1.5rem", { lineHeight: "1.9rem" }],
        "2xl": ["1.25rem", { lineHeight: "1.65rem" }],
        xl: ["1rem", { lineHeight: "1.4rem" }],
        lg: ["0.85rem", { lineHeight: "1.25rem" }],
        base: ["0.75rem", { lineHeight: "1.15rem" }],
        sm: ["0.625rem", { lineHeight: "1rem" }],
        xs: ["0.5rem", { lineHeight: "0.85rem" }],
      },
      screens: {
        ...screens,
        "3xl": "1600px",
        "2xl": "1420px",
        xs: "475px",
      },
      fontFamily: {
        sans: [
          'var(--font-enriqueta)',
          ...fontFamily.sans,
        ],
        title: [
          'var(--font-cinzel)',
          ...fontFamily.sans
        ],
      },
      keyframes: {
        "accordion-down": {
          from: { height: "0" },
          to: { height: "var(--radix-accordion-content-height)" },
        },
        "accordion-up": {
          from: { height: "var(--radix-accordion-content-height)" },
          to: { height: "0" },
        },
      },
      animation: {
        "accordion-down": "accordion-down 0.2s ease-out",
        "accordion-up": "accordion-up 0.2s ease-out",
      },
    },
  },
  plugins: [animate, mask, hyphens],
} satisfies Config;
